import {NAVIGATION_TABS} from "../navigation-tabs-module.consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {NavigationTabModuleTabClickEvent} from "../models/navigation-tab-module.tab-click.event";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";

export class NavigationTabsTabClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = NAVIGATION_TABS.ACTION_TYPES.tabClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NavigationTabModuleTabClickEvent;
  }
}